import LazyLoad from 'vanilla-lazyload';

export default () => ({
    video: null,
    playButtonVisible: false,

    init() {
        this.lazyLoadInstance = new LazyLoad({
            elements_selector: '.lazy',
            threshold: 0
        });

        const selectedVideo = this.$el.querySelector('video');

        if (selectedVideo !== null) {
            this.video = selectedVideo;

            const playOnHover = selectedVideo.getAttribute('data-play-on-hover') === "true";

            if (playOnHover)
                selectedVideo.pause();

            this.playButtonVisible = playOnHover;

            this.lazyLoadInstance.update();

            if (playOnHover) {
                // Check if it's a touch device
                const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

                if (isTouchDevice) {
                    // handle touch events
                    selectedVideo.addEventListener('touchstart', () => {
                        if (selectedVideo.paused) {
                            selectedVideo.play();
                            this.playButtonVisible = false;
                        } else {
                            selectedVideo.pause();
                            this.playButtonVisible = true;
                        }
                    });
                } else {
                    // handle mouse events
                    selectedVideo.addEventListener('mouseover', () => {
                        selectedVideo.play();
                        this.playButtonVisible = false;
                    });

                    selectedVideo.addEventListener('mouseout', () => {
                        selectedVideo.pause();
                        this.playButtonVisible = true;
                    });
                }
            }
        }
    },

    playVideo() {
        if (this.video != null) {
            if (this.video.paused) {
                this.video.play();
                this.playButtonVisible = false;
            } else {
                this.video.pause();
                this.playButtonVisible = true;
            }
        }
    }
})
